var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdispatchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4353",
    "data-name": "Group 4353",
    transform: "translate(5640 8811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1138",
    "data-name": "Rectangle 1138",
    width: 22,
    height: 22,
    transform: "translate(-5640 -8811)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4354",
    "data-name": "Group 4354",
    transform: "translate(-6198.412 -9505.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7449",
    "data-name": "Path 7449",
    d: "M562.505,697.988l3.272,1.932-4.093,6.946-3.272-1.932Z",
    transform: "translate(0 0)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7450",
    "data-name": "Path 7450",
    d: "M1375.542,716.384l3.466-1.556q1.648,3.679,3.3,7.358l-3.467,1.556Q1377.19,720.063,1375.542,716.384Z",
    transform: "translate(-801.893 -16.526)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7451",
    "data-name": "Path 7451",
    d: "M782.586,826.56a4.9,4.9,0,0,1,2.211.176,11.314,11.314,0,0,0-1.856.794c-.815.427-1.594.919-2.39,1.38a1.608,1.608,0,0,0-.793,1.307,1.276,1.276,0,0,0,.29.914,1.612,1.612,0,0,0,.8.493,1.861,1.861,0,0,0,.917-.019,3.425,3.425,0,0,0,.891-.383l2.623-1.523c1.442,1.109,2.889,2.213,4.325,3.33a.962.962,0,0,1,.2.19c.044.067.094.131.138.2a.769.769,0,0,1-1.163.921q-.622-.482-1.243-.967l-.281.4,1.711,1.333a.92.92,0,0,1,.315.92.906.906,0,0,1-.53.629.922.922,0,0,1-.769-.024,1.556,1.556,0,0,1-.262-.183l-1.518-1.182-.281.4,1.346,1.049a1.332,1.332,0,0,1,.374.357.754.754,0,0,1-1.093,1q-.748-.58-1.494-1.162l-.3.384c.276.216.557.424.829.645a.694.694,0,0,1,.1.956.759.759,0,0,1-.872.149,2.942,2.942,0,0,1-.29-.213q-.571-.441-1.149-.873c.1-.1.207-.2.3-.309a.981.981,0,0,0-.622-1.615,1.118,1.118,0,0,0-1.1-1.454,1.268,1.268,0,0,0-.19-.977,1.251,1.251,0,0,0-.787-.521,1.265,1.265,0,0,0-.843.124,1.131,1.131,0,0,0-1.709-.812,1.951,1.951,0,0,0-.367.322l-.583.583c-.253-.232-.5-.471-.746-.71q1.6-2.719,3.2-5.434C780.817,826.952,781.684,826.669,782.586,826.56Z",
    transform: "translate(-214.249 -126.124)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7452",
    "data-name": "Path 7452",
    d: "M970.915,847.589a5.031,5.031,0,0,1,1.356.117q1.323,2.954,2.647,5.908c-.089.016-.178.03-.268.045a1.153,1.153,0,0,0-.124-.162c-.255-.219-.526-.417-.791-.624l-3.579-2.769c-.131-.1-.265-.2-.391-.309l-2.972,1.725a2.806,2.806,0,0,1-.76.316,1.338,1.338,0,0,1-.659,0,1.145,1.145,0,0,1-.529-.329.792.792,0,0,1-.176-.587,1.119,1.119,0,0,1,.558-.914,26.049,26.049,0,0,1,3.668-1.964A6.532,6.532,0,0,1,970.915,847.589Z",
    transform: "translate(-398.68 -146.803)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7453",
    "data-name": "Path 7453",
    d: "M807.106,1158.116a.654.654,0,0,1,.7.319.662.662,0,0,1-.008.651,1.241,1.241,0,0,1-.209.239l-.97.971a.653.653,0,0,1-1.076-.707.976.976,0,0,1,.247-.311c.339-.338.675-.68,1.017-1.015A.646.646,0,0,1,807.106,1158.116Z",
    transform: "translate(-242.473 -451.526)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7454",
    "data-name": "Path 7454",
    d: "M861.221,1202.488a.775.775,0,0,1,.663,1.3q-.787.79-1.576,1.577a1.354,1.354,0,0,1-.333.282.776.776,0,0,1-1-1.126,2.836,2.836,0,0,1,.28-.3l1.521-1.522A.762.762,0,0,1,861.221,1202.488Z",
    transform: "translate(-294.832 -495.078)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7455",
    "data-name": "Path 7455",
    d: "M949.529,1284.073a.639.639,0,0,1,.694.33.647.647,0,0,1-.063.687c-.051.063-.111.115-.167.173q-.672.672-1.343,1.343a.638.638,0,0,1-1.013-.735,1.059,1.059,0,0,1,.251-.308l1.267-1.269A.676.676,0,0,1,949.529,1284.073Z",
    transform: "translate(-381.912 -575.133)",
    fill: "#04be76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7456",
    "data-name": "Path 7456",
    d: "M1036.74,1361.7a.5.5,0,0,1,.51.82q-.387.389-.775.777a1.161,1.161,0,0,1-.238.209.5.5,0,0,1-.7-.628,1.035,1.035,0,0,1,.261-.318l.727-.728A.5.5,0,0,1,1036.74,1361.7Z",
    transform: "translate(-468.191 -651.305)",
    fill: "#04be76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdispatchActive);
export default __webpack_public_path__ + "static/media/mdispatch_active.33946e8c30c9faf0e5db7e0b1cde3cca.svg";
export { ForwardRef as ReactComponent };